import { useFormatPrice } from 'hooks/i18n';
import { CURRENCY_API_CODE } from 'types/modifiers/references';

type MoneyDataType = {
  currency?: string | null;
  amount?: number | null;
};

const MoneyData = ({ currency, amount }: MoneyDataType) => {
  const { allFormat } = useFormatPrice();

  return allFormat[currency || CURRENCY_API_CODE.USD](amount || 0);
};

export default MoneyData;
